import { useMutation } from '@apollo/client';
import { AUTH_CHALLENGE } from 'graphql/auth/mutations/authChallenge.gql';

export default function useAuthChallengeMutation() {
  return useMutation(AUTH_CHALLENGE);
}
